import React from "react";
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/core/styles";
import {themeTypeToBool} from '../../../../../../utils/helpers';
import PoolForm from './Forms/PoolForm';
import RentForm from './Forms/RentForm';

const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        paddingBottom: theme.spacing(1),
        alignItems: "center",
        justifyContent: "flex-start"
    },
    textField: {
        margin: theme.spacing(1),
        width: 225
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    formsContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start"
    },
    inputField: {
        margin: theme.spacing(1),
        width: 225
    },
    label: {
        color: themeTypeToBool(theme.palette.type) ? "#9E9E9E" : "#FAFAFA",
    }
});

const RentTab = props => {
    const {
        classes, rent, isEdit, rentType, checkPoolValidation, checkRentValidation, checkClientNameValidation,
        onCheckboxChange, isError
    } = props;

    return (
        <div className={classes.formsContainer}>
            {rentType === "Pool" ?
                <PoolForm
                    pool={rent}
                    isEdit={isEdit}
                    onNewPool={props.onNewPool}
                    checkPoolValidation={checkPoolValidation}/>
                :
                <RentForm
                    rent={rent}
                    isEdit={isEdit}
                    isError={isError}
                    clients={props.clients}
                    checkRentValidation={checkRentValidation}
                    checkClientNameValidation={checkClientNameValidation}
                    onCheckboxChange={onCheckboxChange}
                />}
        </div>
    );
};

RentTab.propTypes = {
    classes: PropTypes.object,
    rent: PropTypes.object,
    isEdit: PropTypes.bool,
    clients: PropTypes.array,
    onNewPool: PropTypes.func,
    checkPoolValidation: PropTypes.func,
    checkRentValidation: PropTypes.func,
    checkClientNameValidation: PropTypes.func,
    onCheckboxChange: PropTypes.func,
    rentType: PropTypes.string,
    isError: PropTypes.bool,
};

export default withStyles(styles)(RentTab);